var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.mock)?_c('div',[_vm._t("mock")],2):_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }